<template>
    <div id="fixed-box">
		<a href="#"><i class="material-icons">vertical_align_top</i> Scroll Top</a> <br>
		<a v-if="sourceCode!='none'" :href="this.sourceCode" target="_blank"><i class="material-icons">code</i> Source Code</a><br>
    </div>
</template>

<script>
export default {
    props: {
        sourceCode:{
            default: "none",
            type:String
        }
    }
}
</script>

<style scoped>
    #fixed-box{
        position: fixed; 
        bottom: 3em; 
        right: 3em; z-index: 1;
    }
    @media only screen and (max-width: 1000px) {
            #fixed-box{
            display: none
        }
    }
    i{
        vertical-align: middle;
    }
    a{
        text-decoration:none; 
        color:#89ACD7;
        transition: color, 0.1s;
        transition-timing-function: ease;
    }
    a:hover{
        color: #F0F0F0;
    }
</style>